// Whether this machine can hand the browser the whole computer's audio.
//
// Chrome has carried system audio on Windows and ChromeOS since v74 when the user shares the entire
// screen. On macOS it could not until Chrome 141, because Apple only opened system-audio capture to
// third-party apps in macOS 14.2. Anywhere else the only audio a share can carry is a single
// browser tab's — which matters, because a hearing held in the Zoom or Teams desktop app produces
// no tab at all.

const parseChromeMajor = (ua) => Number((ua.match(/Chrom(?:e|ium)\/(\d+)/) || [])[1] || 0);

export async function detectSystemAudioSupport() {
  const ua = navigator.userAgent || "";
  const chromeMajor = parseChromeMajor(ua);
  const uaData = navigator.userAgentData;

  let platform = uaData?.platform || "";
  let platformVersion = "";
  if (uaData?.getHighEntropyValues) {
    try {
      const hints = await uaData.getHighEntropyValues(["platform", "platformVersion"]);
      platform = hints.platform || platform;
      platformVersion = hints.platformVersion || "";
    } catch (err) {
      // The UA string still separates the platforms; only the macOS version is lost.
    }
  }
  if (!platform) {
    if (/Mac OS X|Macintosh/i.test(ua)) platform = "macOS";
    else if (/Windows/i.test(ua)) platform = "Windows";
    else if (/CrOS/i.test(ua)) platform = "Chrome OS";
  }

  if (/windows/i.test(platform) || /cros|chrome\s*os/i.test(platform)) {
    return { os: "windows", systemAudio: true, chromeMajor };
  }

  if (/mac/i.test(platform)) {
    const [major = 0, minor = 0] = String(platformVersion).split(".").map(Number);
    // An unreadable version counts as capable: the share dialog is the real test, and guessing
    // "too old" would push a working Mac down the tab-only path for no reason.
    const macCapable = major ? major > 14 || (major === 14 && minor >= 2) : true;
    return {
      os: "mac",
      systemAudio: chromeMajor >= 141 && macCapable,
      macVersion: platformVersion,
      chromeMajor,
    };
  }

  return { os: "other", systemAudio: false, chromeMajor };
}
